import React, { useCallback } from 'react'
import classNames from 'classnames'
import {
  AdvancedMarker,
  AdvancedMarkerAnchorPoint,
  useAdvancedMarkerRef
} from '@vis.gl/react-google-maps'

type TreeClusterMarkerProps = {
  clusterId: number
  onMarkerClick?: (
    marker: google.maps.marker.AdvancedMarkerElement,
    clusterId: number
  ) => void
  position: google.maps.LatLngLiteral
  size: number
  count: string
}

const FeaturesClusterMarker = ({
  position,
  size,
  onMarkerClick,
  clusterId,
  count
}: TreeClusterMarkerProps) => {
  const [markerRef, marker] = useAdvancedMarkerRef()

  const handleClick = useCallback(
    () => onMarkerClick && onMarkerClick(marker!, clusterId),
    [onMarkerClick, marker, clusterId]
  )

  /*
   * O handoff usa 48px fixos para qualquer contagem. O tamanho vem do proprio
   * conteudo: dimensionar o `AdvancedMarker` por fora comprimia o box interno.
   */
  return (
    <AdvancedMarker
      ref={markerRef}
      position={position}
      zIndex={size}
      onClick={handleClick}
      className={'marker cluster'}
      anchorPoint={AdvancedMarkerAnchorPoint.CENTER}
    >
      <div
        data-testid='cluster-marker'
        className={classNames(
          /*
           * Medidas em px, como no `Marker`: a raiz do app usa font-size 14px,
           * entao as classes do Tailwind em `rem` encolhem 12,5% (`h-12` daria
           * 42px, nao os 48px do handoff).
           */
          'h-[48px] w-[48px] p-gl-spacing-01 select-none',
          'flex justify-center items-center',
          'bg-gl-color-shades-gray-80 rounded-gl-border-radius-md',
          'text-gl-color-shades-white',
          'font-gl-font-weight-semibold text-gl-font-size-md',
          /*
           * O handoff nao desenha borda no cluster. A borda fica transparente
           * para o hover trocar so a cor, sem mudar a geometria. O tom vem do
           * token transparente do design system: o preset substitui
           * `theme.colors`, entao a classe `border-transparent` do Tailwind nao
           * existe neste projeto.
           */
          'border-gl-border-width-md border-gl-color-transparent-white-00',
          'hover:border-sys-color-stroke-hover',
          'shadow-gl-shadow-level-01',
          'animate-scale-in'
        )}
      >
        {count}
      </div>
    </AdvancedMarker>
  )
}

export { FeaturesClusterMarker }
